import { useInkind } from '@gik/api/inkinds/inkind';
import routes from '@gik/core/routes';
import { useInkindCan } from '@gik/core/store/permissions';
import bemBlock from '@gik/core/utils/bemBlock';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { Button } from '@gik/ui-legacy/Button';
import type { ProportionSetting } from '@gik/ui-legacy/KeepProportions';
import { KeepProportions } from '@gik/ui-legacy/KeepProportions';
import { Wishlist } from '@gik/ui-legacy/SvgIcon/GikIcons/Wishlist';
import { SvgIcon } from '@gik/ui-legacy/SvgIcon/SvgIcon';
import WishlistIcon from '@gik/wishlist-page/assets/icon-wishlist.svg';
import PlusIcon from '@heroicons/react/outline/PlusIcon';
import { useTranslation } from 'react-i18next';
import { translationKeys } from './i18n/en';

interface IWishlistEmptyStateProps {
  inkindRouteId: string;
  proportion?: ProportionSetting;
}

function WishlistTurnedOffComp({ inkindRouteId, proportion }: IWishlistEmptyStateProps) {
  const { data: inkindPage } = useInkind(inkindRouteId);
  const canEdit = useInkindCan('manage', inkindRouteId, inkindPage?.groupId);

  return (
    <div className={'bg-neutral-50 p-4 px-6 rounded-lg text-center text-neutral-700 leading-gik'}>
      {canEdit && (
        <p>
          Add a list of gift cards purchased directly through your Page and stored in your InKind Wallet. And/Or link to
          an Amazon Wishlist.
        </p>
      )}
    </div>
  );
}

export const WishlistTurnedOff = withComponentErrorBoundary(WishlistTurnedOffComp);

function WishlistEmptyStateComp({ inkindRouteId, proportion }: IWishlistEmptyStateProps) {
  const { data: inkindPage } = useInkind(inkindRouteId);
  const canEdit = useInkindCan('manage', inkindRouteId, inkindPage?.groupId);
  const bem = bemBlock('wishlist-empty');
  const { t } = useTranslation();

  return (
    <KeepProportions proportion={proportion}>
      <div className={bem()}>
        <WishlistIcon />
        <span className={`${bem('title')}`}>{t(translationKeys.empty).toString()}</span>
        {canEdit && (
          <>
            <p>
              Add to your wishlist by
              <br /> clicking the “
              <SvgIcon className={`${bem('plus-icon')}`} size="xl" Icon={PlusIcon} />“ on items
            </p>

            <Button
              type={'a'}
              // href={inkindPage?.inkindSituations?.[0]?.giftingUrl}
              href={routes.inkinds + '/' + inkindRouteId + '/' + '/gift-picker'}
              variant="secondary"
              prepend={<SvgIcon size="lg" Icon={Wishlist} />}
            >
              {t(translationKeys.findWishlistIdeas).toString()}
            </Button>
          </>
        )}
      </div>
    </KeepProportions>
  );
}

export const WishlistEmptyState = withComponentErrorBoundary(WishlistEmptyStateComp);
